import { Box } from "@mui/material";
import { useTranslation } from "@localization/useTranslation";
import QuestionnaireRisk from "@common/components/questionnaireComponents/questionnaireRisk/QuestionnaireRisk";
import { getQuestionnaireResponseScore } from "@common/questionnaireResponseScore";
import { LegalEntityAuditStatus } from "../../../legalEntity/legalEntityAuditTab/LegalEntityAudit.types";
import { RiskLevel } from "../../../legalEntity/legalEntityClassificationTab/LegalEntityClassificationTab.types";
import TopBarTile from "./TopBarTile";
import { useTopBarTileStyles } from "./TopBarTile.styles";

export interface ITopBarRiskLevelAndScoreTileProps {
    isLoading?: boolean;
    scoreEnabled: boolean;
    riskLevel: RiskLevel | undefined;
    riskLevelName: string | undefined;
    score: number | undefined;
}

function TopBarRiskLevelAndScoreTile(props: ITopBarRiskLevelAndScoreTileProps) {
    const { translateString } = useTranslation();
    const styles = useTopBarTileStyles();

    return (
        <TopBarTile label={translateString("overallRiskLevelAndScore")} isLoading={props.isLoading}>
            {props.riskLevelName && props.score ? (
                <Box sx={styles.riskValue}>
                    <QuestionnaireRisk
                        riskLevel={props.riskLevel}
                        riskName={props.riskLevelName}
                        scoreEnabled={props.scoreEnabled}
                        status={LegalEntityAuditStatus.Submitted}
                    />
                    ({getQuestionnaireResponseScore(true, props.scoreEnabled, props.score, translateString("scoreNotEnabled"))})
                </Box>
            ) : undefined}
        </TopBarTile>
    );
}

export default TopBarRiskLevelAndScoreTile;
